import ClientEditFormComponent from './client-edit-form-component';
import ClientEditFormService from './client-edit-form-service';

/***
 * the sub-page within the Client Edit page that contains a form for editing Client settings.
 */
const clientEditForm = angular
    .module('FacilityData.ClientEdit.ClientEditForm', [])
    .component('clientEditForm', ClientEditFormComponent)
    .service('ClientEditFormService', ClientEditFormService)
    .config(($stateProvider) => {
        'ngInject';

        $stateProvider.state('app.client-edit.client', {
            url:'client/',
            component: 'clientEditForm',
            resolve: {
                industryCodeList: (ClientEditFormService) => ClientEditFormService.getIndustryCodes(),
                groupList: (ClientEditFormService) => ClientEditFormService.getGroups(),

            }
        });

    })
    .name;

export default clientEditForm;


// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit-form/client-edit-form.js